
const duvalParametersLabels = (vm) => {
  if (!vm) return [];
  return [
    {
      label: vm.$t('engineering.chromatography.method-parameters.h2-limit'),
      key: 'h2',
    },
    {
      label: vm.$t('engineering.chromatography.method-parameters.c2h4-limit'),
      key: 'c2H4',
    },
    {
      label: vm.$t('engineering.chromatography.method-parameters.c2h6-limit'),
      key: 'c2H6',
    },
    {
      label: vm.$t('engineering.chromatography.method-parameters.c2h2-limit'),
      key: 'c2H2',
    },
    {
      label: vm.$t('engineering.chromatography.method-parameters.ch4-limit'),
      key: 'cH4',
    },
    {
      label: vm.$t('engineering.chromatography.method-parameters.co-limit'),
      key: 'co',
    },
  ];
};

export default duvalParametersLabels;
